import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PortfolioPerformance, Position, PositionNote, Quote } from '@zero/shared/util-models';

export const positionsActions = createActionGroup({
  source: 'Positions',
  events: {
    'Load Positions': props<{ force: boolean }>(),
    'Update Position Quotes': props<Record<string, Quote>>(),
    'Calculate Portfolio Performance': props<{ performance: PortfolioPerformance; quotesLoaded?: boolean }>(),
    'Calculate Portfolio Performance Failure': emptyProps(),
    'Positions Performance Calculated': props<{ positions: Position[] }>(),
    'Load Positions Notes': props<{ force: boolean }>(),
    'Load Position Note By Isin': props<{ isin: string }>(),
    'Update Position Note': props<{ isin: string; note: string }>(),
    'Subscribe To Position Quotes': emptyProps(),
    'Unsubscribe From Position Quotes': emptyProps(),
    'Subscribe To Position Quote': props<{ isin: string }>(),
    'Unsubscribe From Position Quote': props<{ isin: string }>(),
    'Set Loading': props<{ loading: boolean }>(),
    'Set Performance Calculated': props<{ calculated: boolean }>(),
    'Update Position Entry Quote': props<{ isin: string; entryQuote: number }>(),
    'Position Quotes Subscription Failure': emptyProps(),
    'Set Position Categories': props<{ categories: string[] }>(),
  },
});

export const positionsApiActions = createActionGroup({
  source: 'Positions API',
  events: {
    'Load Positions Success': props<{ positions: Position[] }>(),
    'Load Positions Failure': props<{ error: HttpErrorResponse }>(),
    'Load Positions Notes Success': props<{ notes: PositionNote[] }>(),
    'Load Positions Notes Failure': props<{ error: HttpErrorResponse }>(),
    'Load Position Note By Isin Success': props<{ note: PositionNote }>(),
    'Load Position Note By Isin Failure': props<{ error: HttpErrorResponse }>(),
    'Update Position Note Success': props<{ note: PositionNote }>(),
    'Update Position Note Failure': props<{ error: HttpErrorResponse }>(),
    'Update Position Entry Quote Success': props<{ position: Position }>(),
    'Update Position Entry Quote Failure': props<{ error: HttpErrorResponse }>(),
  },
});
